module.exports = __webpack_public_path__ + "img/r5.2a658d74.png";